import { BaseState } from "./BaseState";
import { StateManager } from "../GameStateManager";
import { EventData } from "../EventData";
import { EulerStateManager } from "../EulerStateManager";
import { EulerStateEvents, EventDataEvents } from "../Consts";

class PreEventState extends BaseState<StateManager> {
  public id = "PreEventState"; // A unique identifier for the state
  constructor(stateManager: StateManager) {
    super(stateManager); // Pass the StateManager to the base class
    this.bindEvents();
    this.subscribeToEvents();
  }

  public onEnter(stateManager: StateManager): void {
    this.stateManager = stateManager; // Set the StateManager reference
    super.onEnter(stateManager); // Call the super method
    this.stateManager.enteredPreEventGameState();
  }

  private bindEvents(): void {
    this.transition = this.transition.bind(this);
  }

  private subscribeToEvents(): void {
    const eulerStateManager = EulerStateManager.getInstance();
    eulerStateManager.subscribeToEvent(
      EulerStateEvents.ON_ENTER_NO_MORE_BETS_STATE,
      this.transition,
    );
  }

  private transition(): void {
    this.stateManager?.changeState(this.stateManager.warmUpState);
  }

  public onExit(): void {
    super.onExit();
  }
}

export { PreEventState };
